import api from '../api'

export default {
    namespaced: true,
    state: {
        list: [],
        rechargeChip:0,
    },
    mutations: {
        setMttMazngZhuList(state, info) {
            state.list = info
        }
    },
    getters: {
        getMttMazngZhu(state) {
            return state.list;
        }
    },
    actions: {
        getMttMazngZhuList(store, type) {
            return api.post(`/mangZhuGrade/list/${type}`, '指定对应的排名奖励')
        },
        addMttMazngZhuTemplate() {
            return api.post(`/mangZhuGrade/addTemplate`, '增加盲注模板')
        },
        updateMttMazngZhu(store, params) {
            return api.post(`/mangZhuGrade/update/`, '修改排名奖励', params)
        },

    }
}